function Member(params) {
    const member = params.member;
    if (!member)
    {
        return null;
    }

    return (
        <span style={{
            color: '#374151',
            backgroundColor: '#f3f4f6',
            padding: '2px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            border: '1px solid #e5e7eb'
        }}>
            {member.nickName}
        </span>
    );
}

export default Member;